angular.module('lwNamb').directive(
  'coachPaneScorecards',

  [
    function() {
      return {
        restrict: 'E',
        templateUrl: 'partials/directives/coach-pane-scorecards.html',
        scope: {
          userId: '@',
          paneId: '@',
        },
        replace: true,
        controller: [
          '$scope',
          'State',
          'coachService',
          '$log',
          function($scope, State, coachService, $log) {
            $scope.isLoading = true;

            coachService.getScorecardAssignments($scope.userId).then(
              function(scorecardAssignments) {
                $scope.scorecardAssignments = scorecardAssignments
                  .filter(function(scorecardAssignment) {
                    return (
                      scorecardAssignment.scorecards &&
                      Array.isArray(scorecardAssignment.scorecards.tasks) &&
                      scorecardAssignment.scorecards.tasks.length > 0
                    );
                  })
                  .map(function(scoreCardAssignment) {
                    var tasks = scoreCardAssignment.scorecards.tasks;
                    if (Array.isArray(tasks)) {
                      scoreCardAssignment.scorecards.tasks = tasks.sort();
                    }
                    return scoreCardAssignment;
                  });
                $scope.isLoading = false;
              },
              function(reason) {
                $log.error(reason);
                $scope.isLoading = false;
                $scope.isError = true;
              }
            );

            var state = State($scope.paneId);
            $scope.selected = state.get();

            $scope.select = function(scorecardTask, scorecardId) {
              state.put('menu', 'scorecard');
              state.put('scorecardTask', scorecardTask);
              state.put('scorecardId', scorecardId);
            };

            $scope.close = function() {
              State($scope.paneId).clear();
            };
          },
        ],
      };
    },
  ]
);
